import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=650c654d&"
import script from "./LocaleSelector.vue?vue&type=script&lang=ts&"
export * from "./LocaleSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports